import { z } from 'zod';

export const WorkstreamTemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  nbTasks: z.number(),
});

export type WorkstreamTemplate = z.infer<typeof WorkstreamTemplateSchema>;
